import React, { useState } from 'react';

import { FieldValues, UseFormRegister, Validate } from 'react-hook-form';

import passwordRequirements from 'components/Form/AccountForm/passwordRequirements';
import { EyeIcon } from 'components/Icons';
import Input, { InputProps } from 'components/Inputs/Input';
import PasswordRequirements from 'components/PasswordRequirements';
import { getMessageForInvalidFields } from 'utils/validationUtils';

import styles from './PasswordInput.module.scss';

export interface PasswordInputProps extends InputProps {
  name: string;
  register: UseFormRegister<FieldValues>;
  errorMessage?: string;
  isRequired?: boolean;
  withPasswordRequirements?: boolean;
  validate?: Validate<string> | Record<string, Validate<string>> | undefined;
}

const PasswordInput = ({
  name,
  register,
  withPasswordRequirements,
  isRequired = true,
  errorMessage,
  validate,
  ...rest
}: PasswordInputProps) => {
  const [isPasswordValueVisible, setIsPasswordValueVisible] = useState(false);

  return (
    <Input
      name={name}
      type={isPasswordValueVisible ? 'text' : 'password'}
      caption={
        withPasswordRequirements ? (
          <PasswordRequirements items={passwordRequirements} password={rest.value as string} error={errorMessage} />
        ) : undefined
      }
      errorMessage={!withPasswordRequirements ? errorMessage : ''}
      inputRef={
        register(name, {
          required: {
            value: isRequired,
            message: 'Password is required',
          },
          validate: withPasswordRequirements
            ? (password) =>
                passwordRequirements.every((requirement) => requirement.isValid(password)) ||
                getMessageForInvalidFields('Password')
            : validate,
        }).ref
      }
      endAdornment={() => (
        <EyeIcon
          open={isPasswordValueVisible}
          className={styles.eyeIcon}
          onClick={() => setIsPasswordValueVisible(!isPasswordValueVisible)}
        />
      )}
      {...rest}
    />
  );
};

export default PasswordInput;
